import React from 'react';
import WorldMapView from './WorldMapView';

const IncidenceMapView = () => {
  return <WorldMapView variant="green" showBanners={false} />;
};

export default IncidenceMapView;
